import { withInstall } from '@vuemap/vue-amap-util'
import Text from './Text.vue'

export const ElAmapText = withInstall(Text)
export default ElAmapText
